import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import DOMPurify from "dompurify";

@Pipe({
  name: "safeHTML",
  standalone: true,
})
export class SafeHtmlPipee implements PipeTransform {
  constructor(private domSanitize: DomSanitizer) {}
  transform(value: any, type: "html" | "url" | "style" = "html") {
    if (!value) {
      return "N.A.";
    }

    value = DOMPurify.sanitize(value);
    switch (type) {
      case "html":
        return this.domSanitize.bypassSecurityTrustHtml(value);
      case "url":
        return this.domSanitize.bypassSecurityTrustResourceUrl(value);
      case "style":
        return this.domSanitize.bypassSecurityTrustStyle(value);
      default:
        throw new Error(`Invalid sanitization type: ${type}`);
    }
  }
}
